import { render, staticRenderFns } from "./RefundDetailsSkeleton.vue?vue&type=template&id=380877d4&"
import script from "./RefundDetailsSkeleton.vue?vue&type=script&lang=js&"
export * from "./RefundDetailsSkeleton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports